<template>
    <CustomerManagerList 
        ref="customerManagerList" />
</template>

<script>
import CustomerManagerList from '@/view/account-management/customerManager-user-management/customerManager-user-list.vue';

export default {
    name: 'customerManagerList',
    components: {
        CustomerManagerList
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
